export const isStringEmptyOrNull = (str?: string): boolean => {
    try {
        if (str == null || str == undefined) {
            return true;
        }

        let value = String(str);
        return value.trim().length == 0;
    } catch (e) {
        console.error(e);
        return false;
    }
}

export const padString = ({ str, maxLength, padChar = '.', padLength = 3, padEnd = false }: { str: string, maxLength: number, padChar?: string, padLength?: number, padEnd?: boolean }): string => {
    if(!str || str.length < maxLength) {
        return str;
    }

    const padding = padChar.repeat(padLength);
    
    let paddedStr = str;
    if(padEnd) {
        paddedStr = str.slice(0, maxLength) + padding;
    } else {
        paddedStr = padding + str.slice(str.length - maxLength);
    }
    
    return paddedStr;
}

export const toTitleCase = (str: string): string => {
    if(!str) {
        return '';
    }

    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export const truncateString = (str: string, maxLength: number, prefix: boolean) => {
    if (!str || str.length < maxLength) {
        return str;
    }

    const sliced = str.slice(str.length - maxLength); 

    return prefix ? `...${sliced}` : `${sliced}...`;
}

export const getYesNoFromBoolean = (value: any): string => {
    if (value == false) {
      return "No";
    } else if (value == true) {
      return "Yes";
    }
    return "";
  }